import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/karma-ac/MindalooShell.tsx");
